export const USER = 'user'

export const EXPIRED_TIME = 300000 // 超时时间5分钟